import { INVALIDATE_OPERATEURS } from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import {
  ADD_OPERATEUR_API_ROUTE,
  UPDATE_OPERATEUR_API_ROUTE,
  DELETE_OPERATEUR_API_ROUTE,
} from 'routes/api/endpoints';

const operateursApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    // Mutation for creating a new operateur instance
    createOperateur: build.mutation({
      query(data) {
        return {
          url: ADD_OPERATEUR_API_ROUTE,
          method: 'POST',
          body: data.formData,
          // Ne pas mettre formData: true, laisser le navigateur gérer Content-Type
        };
      },
      invalidatesTags: [INVALIDATE_OPERATEURS],
    }),

    // Mutation for updating an existing operateur instance
    updateOperateur: build.mutation({
      query: ({ id, ...updateData }) => ({
        url: `${UPDATE_OPERATEUR_API_ROUTE}${id}/`,
        method: 'PUT',
        body: updateData,
      }),
      invalidatesTags: [INVALIDATE_OPERATEURS],
    }),

    // Mutation for deleting an existing operateur instance
    deleteOperateur: build.mutation({
      query: ({id}) => ({
        url: `${DELETE_OPERATEUR_API_ROUTE}${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [INVALIDATE_OPERATEURS],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateOperateurMutation,
  useUpdateOperateurMutation,
  useDeleteOperateurMutation,
} = operateursApi;
